import $ from "jquery";

const pageInit = () => {
    const $preloader = $(".js-preload-page");

    const initAnimations = () => {
        const $animElements = $("[class*='animation-']");
        const observerOptions = { root: null, threshold: 0.3 };

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const animationClass = Array.from(el.classList).find((cls) =>
                        cls.startsWith("animation-")
                    );

                    if (animationClass) {
                        if (animationClass === "animation-up-fade-in") {
                            const $parentSplitter = $(el).closest(".js-word-splitter");

                            if ($parentSplitter.length) {
                                const $words = $parentSplitter.find('.word-wrapper .word.animation-up-fade-in');

                                $words.each((i, word) => {
                                    setTimeout(() => {
                                        $(word).addClass("animation-up-fade-in-active");
                                    }, i * 50);
                                });
                            }
                        } else {
                            $(el).addClass(animationClass + "-active");
                        }
                    }



                    obs.unobserve(el);
                }
            });
        }, observerOptions);

        $animElements.each(function () {
            observer.observe(this);
        });
    };

    if ($preloader.length) {
        const startTime = Date.now();

        $(window).on("load", function () {
            const elapsed = Date.now() - startTime;
            const minDuration = 1600;
            const remaining = Math.max(0, minDuration - elapsed);

            setTimeout(() => {
                $preloader.addClass("hidden");
                initAnimations(); // run animation after preloader is complete
            }, remaining);
        });
    } else {
        // if there is no preloader, run the animation immediately
        initAnimations();
    }
};

try {
    pageInit();
} catch (error) {
    console.error("pageInit", error);
}
